import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { UserActivityLog, UserActivityLogNode, UserActivityEntities, ReportDiscountNode } from '../user-activity-log.model';

export enum UserActivityLogActionTypes {
  // GetUserActivityLogs
  GetUserActivityLogs = '[UserActivityLog] Get UserActivityLogs',
  LoadUserActivityLogs = '[UserActivityLog] Load UserActivityLogs',
  GetUserActivityLogsFail = '[UserActivityLog] Get UserActivityLogs Fail',
  
  // GetProIncomeList
  GetProIncomeList = '[UserActivityLog] Get ProIncomeList',
  LoadProIncomeList = '[UserActivityLog] Load ProIncomeList',
  GetProIncomeListFail = '[UserActivityLog] Get ProIncomeList Fail',
  
  // UpdateProIncome
  UpdateProIncome = '[UserActivityLog] Update ProIncome',
  UpdateProIncomeSuccess = '[UserActivityLog] Update ProIncome Success',
  UpdateProIncomeFail = '[UserActivityLog] Update ProIncome Fail',
  
  // Read report discount list
  GetReportDiscountList = '[UserActivityLog] Get Report Discount List',
  LoadReportDiscountList = '[UserActivityLog] Load Report Discount List',
  GetReportDiscountListFail = '[UserActivityLog] Get Report Discount List Fail',
  
  // Add report discount
  AddReportDiscount = '[UserActivityLog] Add Report Discount',
  AddReportDiscountSuccess = '[UserActivityLog] Add Report Discount Success',
  AddReportDiscountFail = '[UserActivityLog] Add Report Discount Fail',
  
  // Update report discount
  UpdateReportDiscount = '[UserActivityLog] Update Report Discount',
  UpdateReportDiscountSuccess = '[UserActivityLog] Update Report Discount Success',
  UpdateReportDiscountFail = '[UserActivityLog] Update Report Discount Fail',
  
  // Delete report discount
  DeleteReportDiscount = '[UserActivityLog] Delete Report Discount',
  DeleteReportDiscountSuccess = '[UserActivityLog] Delete Report Discount Success',
  DeleteReportDiscountFail = '[UserActivityLog] Delete Report Discount Fail',
}

export class GetUserActivityLogs implements Action {
  readonly type = UserActivityLogActionTypes.GetUserActivityLogs;
  constructor(public payload: any = null) {}
}

export class LoadUserActivityLogs implements Action {
  readonly type = UserActivityLogActionTypes.LoadUserActivityLogs;
  constructor(public payload: UserActivityEntities) {}
}

export class GetUserActivityLogsFail implements Action {
  readonly type = UserActivityLogActionTypes.GetUserActivityLogsFail;
  constructor(public payload: any = null) {}
}

export class GetProIncomeList implements Action {
  readonly type = UserActivityLogActionTypes.GetProIncomeList;
  constructor(public payload: any = null) {}
}

export class LoadProIncomeList implements Action {
  readonly type = UserActivityLogActionTypes.LoadProIncomeList;
  constructor(public payload: any) {}
}

export class GetProIncomeListFail implements Action {
  readonly type = UserActivityLogActionTypes.GetProIncomeListFail;
  constructor(public payload: any = null) {}
}

export class UpdateProIncome implements Action {
  readonly type = UserActivityLogActionTypes.UpdateProIncome;
  constructor(public payload: any = null) {}
}

export class UpdateProIncomeSuccess implements Action {
  readonly type = UserActivityLogActionTypes.UpdateProIncomeSuccess;
  constructor(public payload: any = null) {}
}
export class UpdateProIncomeFail implements Action {
  readonly type = UserActivityLogActionTypes.UpdateProIncomeFail;
  constructor(public payload: any = null) {}
}

export class GetReportDiscountList implements Action {
  readonly type = UserActivityLogActionTypes.GetReportDiscountList;
  constructor(public payload: ReportDiscountNode = null) {}
}

export class LoadReportDiscountList implements Action {
  readonly type = UserActivityLogActionTypes.LoadReportDiscountList;
  constructor(public payload: any) {}
}

export class GetReportDiscountListFail implements Action {
  readonly type = UserActivityLogActionTypes.GetReportDiscountListFail;
  constructor(public payload: any = null) {}
}

  // Add report discount
export class AddReportDiscount implements Action {
  readonly type = UserActivityLogActionTypes.AddReportDiscount;
  constructor(public payload: any = null) {}
}

export class AddReportDiscountSuccess implements Action {
  readonly type = UserActivityLogActionTypes.AddReportDiscountSuccess;
  constructor(public payload: any = null) {}
}

export class AddReportDiscountFail implements Action {
  readonly type = UserActivityLogActionTypes.AddReportDiscountFail;
  constructor(public payload: any = null) {}
}

  // Update report discount
export class UpdateReportDiscount implements Action {
  readonly type = UserActivityLogActionTypes.UpdateReportDiscount;
  constructor(public payload: any = null) {}
}

export class UpdateReportDiscountSuccess implements Action {
  readonly type = UserActivityLogActionTypes.UpdateReportDiscountSuccess;
  constructor(public payload: any = null) {}
}

export class UpdateReportDiscountFail implements Action {
  readonly type = UserActivityLogActionTypes.UpdateReportDiscountFail;
  constructor(public payload: any = null) {}
}

  // Delete report discount
export class DeleteReportDiscount implements Action {
  readonly type = UserActivityLogActionTypes.DeleteReportDiscount;
  constructor(public payload: any = null) {}
}

export class DeleteReportDiscountSuccess implements Action {
  readonly type = UserActivityLogActionTypes.DeleteReportDiscountSuccess;
  constructor(public payload: any = null) {}
}

export class DeleteReportDiscountFail implements Action {
  readonly type = UserActivityLogActionTypes.DeleteReportDiscountFail;
  constructor(public payload: any = null) {}
}

export type UserActivityLogActions =
 GetUserActivityLogs
 | LoadUserActivityLogs
 | GetUserActivityLogsFail
 | GetProIncomeList
 | LoadProIncomeList
 | GetProIncomeListFail
 | UpdateProIncome
 | UpdateProIncomeSuccess
 | UpdateProIncomeFail
 | GetReportDiscountList
 | LoadReportDiscountList
 | GetReportDiscountListFail
 | AddReportDiscount
 | AddReportDiscountSuccess
 | AddReportDiscountFail
 | UpdateReportDiscount
 | UpdateReportDiscountSuccess
 | UpdateReportDiscountFail
 | DeleteReportDiscount
 | DeleteReportDiscountSuccess
 | DeleteReportDiscountFail;
